import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddGen = createAsyncThunk(
  "other/AddGen",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/gen-create/`, data)
    return response.data
  }
); 

export const UpdateGen = createAsyncThunk(
  "other/UpdateGen",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/gen-update/${data.id}/`, data)
    return response.data
  }
);

export const GetGenList = createAsyncThunk(
  "user/GetGenList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/gen-list/`)
    return data
  }
);

export const DeleteGen = createAsyncThunk(
  "other/DeleteGen",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/gen-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

